import React from 'react'
import {
  DeleteOutlined,
  InfoCircleOutlined,
  LeftOutlined,
  MinusOutlined,
  PlusOutlined,
  RightOutlined,
  SearchOutlined
} from '@ant-design/icons'

const ICONS_BY_TYPE = {
  delete: DeleteOutlined,
  'info-circle': InfoCircleOutlined,
  left: LeftOutlined,
  minus: MinusOutlined,
  plus: PlusOutlined,
  right: RightOutlined,
  search: SearchOutlined
}

const LegacyIcon = ({ type, ...restProps }) => {
  const IconComponent = ICONS_BY_TYPE[type]

  if (!IconComponent) {
    return null
  }

  return <IconComponent {...restProps} />
}

export default LegacyIcon
